// ** React Imports
import { Fragment, useEffect, memo, useState } from "react"

// ** Third Party Components
import classnames from "classnames"
// import { useParams } from 'react-router-dom'
// ** Store & Actions
import { useSelector, useDispatch } from "react-redux"
import {
  handleContentWidth,
  handleMenuCollapsed,
  handleMenuHidden
} from "@store/layout"

// ** ThemeConfig
import themeConfig from "@configs/themeConfig"

// ** Styles
// import { AnimatePresence } from "framer-motion/dist/framer-motion"
import "animate.css/animate.css"
import GlobalVariable from "../../../../settings/global"
// const headerText = GlobalVariable.headerText

const LayoutWrapper = (props) => {
  // ** Props
  const { children, routeMeta } = props

  // ** Store Vars
  const dispatch = useDispatch()
  // const { catCode } = useParams()
  const store = useSelector((state) => state)

  const navbarStore = store.navbar
  const layoutStored = store.layout.layout
  const contentWidth = store.layout.contentWidth
  const [windowWidth, setWindowWidth] = useState(window.innerWidth)
  const handleWindowWidth = () => {
    setWindowWidth(window.innerWidth)
  }
  //** Vars
  const appLayoutCondition =
    (layoutStored.layout === "horizontal" && !routeMeta) ||
    (layoutStored.layout === "horizontal" && routeMeta && !routeMeta.appLayout)
  const Tag = appLayoutCondition ? "div" : Fragment

  // ** Clean Up Function
  const cleanUp = () => {
    if (routeMeta) {
      if (
        routeMeta.contentWidth &&
        routeMeta.contentWidth === store.layout.contentWidth
      ) {
        dispatch(handleContentWidth(themeConfig.layout.contentWidth))
      }
      if (
        routeMeta.menuCollapsed &&
        routeMeta.menuCollapsed === store.layout.menuCollapsed
      ) {
        dispatch(handleMenuCollapsed(!store.layout.menuCollapsed))
      }
      if (
        routeMeta.menuHidden &&
        routeMeta.menuHidden === store.layout.menuHidden
      ) {
        dispatch(handleMenuHidden(!store.layout.menuHidden))
      }
    }
  }

  useEffect(() => {
    if (window !== undefined) {
      window.addEventListener("resize", handleWindowWidth)
    }
  }, [windowWidth])

  // ** ComponentDidMount
  useEffect(() => {
    if (routeMeta) {
      if (routeMeta.contentWidth) {
        dispatch(handleContentWidth(routeMeta.contentWidth))
      }
      if (routeMeta.menuCollapsed) {
        dispatch(handleMenuCollapsed(routeMeta.menuCollapsed))
      }
      if (routeMeta.menuHidden) {
        dispatch(handleMenuHidden(routeMeta.menuHidden))
      }
    }
    return () => cleanUp()
  }, [routeMeta])

  return (
    // <AnimatePresence>
    <div
      className={classnames(`app-content content overflow-hidden ${(location.pathname !== '/home') ? 'rlm_Publications_warpper1' : ''}`, {
        [routeMeta ? routeMeta.className : ""]:
          routeMeta && routeMeta.className,
        "show-overlay": navbarStore.query.length
      })}
    >
      <div className="content-overlay"></div>
      <div className="header-navbar-shadow" />
      <div
        className={classnames({
          "content-wrapper": routeMeta && !routeMeta.appLayout,
          "content-area-wrapper": routeMeta && routeMeta.appLayout,
          "pb-1": contentWidth === "boxed",
          collapse_menu: !store.layout.menuCollapsed
        })}
      // style={{ height: '100%', marginRight: '-17px', marginTop: headerText ? 'opx' : '2px', marginLeft: windowWidth <= 1200 ? "-17px" : store.layout.menuCollapsed ? '210px' : '210px' }}
      >
        <Tag {...(appLayoutCondition ? { className: "content-body" } : {})}>
          {children}
        </Tag>
      </div>
    </div>
    // </AnimatePresence>
  )
}

export default memo(LayoutWrapper)
